var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconSocialPinterest(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.2044 22.6388C17.3552 22.6388 22.3432 17.6508 22.3432 11.5C22.3432 5.34922 17.3552 0.361237 11.2044 0.361237C5.05366 0.361237 0.0656738 5.34922 0.0656738 11.5C0.0656738 16.156 2.92381 20.1456 6.98093 21.8099C6.6372 19.1509 7.25429 16.9583 7.85432 14.8263C8.07455 14.0438 8.29248 13.2694 8.45976 12.4832C7.37955 10.7485 8.59319 7.24742 10.8743 8.11158C12.2193 8.61975 11.718 10.1217 11.2169 11.6231C10.6715 13.2569 10.1265 14.8899 11.9609 15.2409C15.6336 15.9462 17.1332 9.16637 14.8584 6.96149C11.5606 3.78443 5.27633 6.89159 6.05153 11.4411C6.14685 12.0067 7.07455 12.8962 7.07455 12.8962C7.07455 12.8962 7.03007 13.4363 6.78862 14.4339C4.67904 13.9891 3.79581 12.407 3.87841 10.2974C4.0055 6.84076 7.13174 4.42619 10.2707 4.08942C14.2357 3.6637 17.9592 5.47462 18.4803 9.03293C19.0585 13.0487 16.6884 17.395 12.4438 17.0836C11.582 17.0217 11.0949 16.6994 10.5252 16.3225C10.3346 16.1963 10.1347 16.0641 9.90851 15.9335C9.43003 18.3259 8.85087 20.6235 7.1934 21.8945C8.43799 22.3752 9.79049 22.6388 11.2044 22.6388Z",
    fill: "#00A0F3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSocialPinterest);
export default __webpack_public_path__ + "static/media/IconSocialPinterest.d4782f3bb806f3c3c58bc2235daee489.svg";
export { ForwardRef as ReactComponent };